const getUserPermissions: (
  isPrime: boolean,
  isLogged: boolean
) => 'prime' | 'nonprime' | 'public' = (isPrime, isLogged) => {
  if (isPrime) {
    return 'prime';
  }

  if (isLogged) {
    return 'nonprime';
  }

  return 'public';
};

export default getUserPermissions;
